import React from "react";

const BS5_FormValidation = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_FormValidation Component</h2>
      <p>This is the BS5_FormValidation component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_FormValidation;
